/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgradeRuleEtcResponse
 */
export interface UpgradeRuleEtcResponse {
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleEtcResponse
     */
    deviceTypeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleEtcResponse
     */
    superGroupName: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleEtcResponse
     */
    loaderVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleEtcResponse
     */
    firmwareVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleEtcResponse
     */
    uiVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleEtcResponse
     */
    customFirmware1Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleEtcResponse
     */
    customFirmware2Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleEtcResponse
     */
    customFirmware3Version: string | null;
}

export function UpgradeRuleEtcResponseFromJSON(json: any): UpgradeRuleEtcResponse {
    return UpgradeRuleEtcResponseFromJSONTyped(json, false);
}

export function UpgradeRuleEtcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeRuleEtcResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceTypeName': json['deviceTypeName'],
        'superGroupName': json['superGroupName'],
        'loaderVersion': json['loaderVersion'],
        'firmwareVersion': json['firmwareVersion'],
        'uiVersion': json['uiVersion'],
        'customFirmware1Version': json['customFirmware1Version'],
        'customFirmware2Version': json['customFirmware2Version'],
        'customFirmware3Version': json['customFirmware3Version'],
    };
}

export function UpgradeRuleEtcResponseToJSON(value?: UpgradeRuleEtcResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceTypeName': value.deviceTypeName,
        'superGroupName': value.superGroupName,
        'loaderVersion': value.loaderVersion,
        'firmwareVersion': value.firmwareVersion,
        'uiVersion': value.uiVersion,
        'customFirmware1Version': value.customFirmware1Version,
        'customFirmware2Version': value.customFirmware2Version,
        'customFirmware3Version': value.customFirmware3Version,
    };
}

